var React = require('react');

function DoubleQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M80 60V42.1733C80 37.1114 78.9916 31.9395 76.9748 26.6575C74.958 21.3755 72.2969 16.3961 68.9916 11.7194C65.6863 7.04263 62.1008 3.13617 58.2353 0L42.437 9.16094C45.5742 14.0028 48.1513 19.0646 50.1681 24.3466C52.1289 29.6286 53.1092 35.5158 53.1092 42.0082V60H80ZM37.563 60V42.1733C37.563 37.1114 36.5546 31.9395 34.5378 26.6575C32.521 21.3755 29.8599 16.3961 26.5546 11.7194C23.2493 7.04263 19.6639 3.13617 15.7983 0L0 9.16094C3.13725 14.0028 5.71429 19.0646 7.73109 24.3466C9.69188 29.6286 10.6723 35.5158 10.6723 42.0082V60H37.563Z","fill":"#F2F2F2"}));
}

DoubleQuote.defaultProps = {"width":"80","height":"60","viewBox":"0 0 80 60","fill":"none"};

module.exports = DoubleQuote;

DoubleQuote.default = DoubleQuote;
